'use strict'

angular.module('rmRundown')
    .directive('rmRundownHeader', require('./rm_rundown_header'))
    .directive('rmRundownNavigation', require('./rm_rundown_navigation').default)
    .directive('rmRundownNavigationItem', require('./rm_rundown_navigation_item'))
    .directive('rmRundownDraftNavigation', require('./rm_rundown_draft_navigation').default)
    .directive('rmRundownDraftNavigationItem', require('./rm_rundown_draft_navigation_item'))
    .directive('rmRundownPreps', require('./rm_rundown_preps').default)
    .directive('rmRelatedBroadcastPicker', require('./related-broadcast-picker'))
    .directive('rmFixedStarttime', require('./fixed-starttime'))


require('./ymodels')
